import React from "react";
import { Checkbox } from "@assets/spa/control/checkbox";
export function ForminatorCheckbox(props) {
    const { onChange, value = [], options, } = props;
    return React.createElement(React.Fragment, null, options && options.length > 0 && options.map((opt) => {
        return React.createElement(Checkbox, { key: opt.key, label: opt.label, onChange: (checked) => {
                if (checked)
                    onChange([...value, opt.value]);
                else {
                    const values = value.filter((v) => v !== opt.value);
                    onChange(values.length > 0 ? values : undefined);
                }
            }, checked: (value).includes(opt.value) });
    }));
}
